import { render, staticRenderFns } from "./ProductACVTextsTableDetails.vue?vue&type=template&id=5dd2056c&scoped=true&"
import script from "./ProductACVTextsTableDetails.vue?vue&type=script&lang=js&"
export * from "./ProductACVTextsTableDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd2056c",
  null
  
)

export default component.exports